function setHeader(options) {
    var config = {};
    return config;
}
export function requestSuccessFunc(requestObj) {
    requestObj.headers = Object.assign({}, requestObj.headers, setHeader(requestObj));
    return requestObj;
}
export function requestFailFunc(requestError) {
    return Promise.reject(requestError);
}
export function responseSuccessFunc(responseObj) {
    var _data = responseObj.data;
    if (_data && (_data.code === '200' || _data.code === 200)) {
        return _data.data || _data;
    }
    else {
        return Promise.reject(_data);
    }
}
export function responseFailFunc(responseError) {
    var message = responseError.message, response = responseError.response;
    console.log(message, response);
    return Promise.reject(responseError);
}



//////////////////
// WEBPACK FOOTER
// ./src/request/interceptor.ts
// module id = null
// module chunks = 